import styled from 'styled-components';

const StepContent = styled.div`
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  overflow-y: hidden;
`;

export const StepContentBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: scroll;
`;

export default StepContent;
